/**
 * @author vishwadeep.kapoor
 * GiftCardLanding actions
 * @todo have reference @see /client/containers/GiftCardsList/actions.js
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endPoints from '../../config/endPoints';
import { DEFAULT_ACTION, FETCH_LANDING_SUCCESS, STORE_LYRA_GIFTCARD } from './constants';
import {
  DEFAULT_WEB_CONSTANT,
} from '../HomePage/constants';
export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}
const gitCardSuccessAction = (payload) => ({ type: FETCH_LANDING_SUCCESS, payload });
export const storeLyraGiftCard = (payload = {}) => ({ type: STORE_LYRA_GIFTCARD, payload });

export const fetchGiftCardLanding = () => async (dispatch, getState, api) => {
  try {
    const { result } = await reqHandler.getHandler(api, endPoints.GET_GIFTCARD_LANDING, DEFAULT_WEB_CONSTANT);
    dispatch(gitCardSuccessAction({ pageData: result }));
  } catch (err) {
    console.log('error on getGiftCardLanding........', err);
  }
};



// WEBPACK FOOTER //
// client/containers/GiftCardLanding/actions.js